import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import clsx from 'clsx';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  Box,
  TextField,
  InputLabel,
  Switch,
  MenuItem,
  Select,
  FormControl,
  Typography,
} from '@material-ui/core';

import { Save } from '@material-ui/icons';
import { toast } from 'react-toastify';
import { useStyles } from './styles';
import { AcademyiaData, CategoryData, FilesData } from 'services/dataService';

export default ({ className, isModalInsert, idCategory, ...rest }) => {
  const [status, setStatus] = useState(true);
  const [exampleString, setExampleString] = useState();
  const [academy, setAcademy] = useState('');
  const [categories, setCategories] = useState([]);
  const [card, setCard] = useState();
  const [cardUrl, setCardUrl] = useState();
  const [loading, setLoading] = useState(true);

  const { id } = useParams();

  const { register, handleSubmit, errors, setValue, control } = useForm();
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation([
    'title',
    'form',
    'button',
    'validation',
    'toastify',
  ]);
  const currencies = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
  ];

  useEffect(() => {
    if (id && !isModalInsert) {
      const fetchData = async () => {
        try {
          const response = await AcademyiaData.getAcademyIaById(id);
          const data = response.data;
  
          if (data.card) {
            setCardUrl(data.card.url);
          }
  
          setAcademy(data);
          setStatus(data.status);
  
          // Campos normais (sem tratar HTML)
          const fields = [
            'name',
            'description',
            'url_video',
            'url_tool',
            'about',
            'difficulty',
            'id_category',
            'id_file'
          ];
  
          fields.forEach((field) => setValue(field, data[field]));
  
          // Tratamento do campo "examples" (com EditorState)
          if (data?.examples) {
            const blocksFromHtml = htmlToDraft(data?.examples);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
            setExampleString(editorState);
          }
  
          const extractLinkData = (htmlString) => {
            if (!htmlString) return { text: '', link: '' };
            const match = htmlString.match(/<a\s+[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/i);
            if (match) {
              return { link: match[1], text: match[2] };
            }
            return { text: htmlString, link: '' };
          };
  
          const sm1 = extractLinkData(data.supplementary_material_1);
          const sm2 = extractLinkData(data.supplementary_material_2);
          const sm3 = extractLinkData(data.supplementary_material_3);
  
          setValue('supplementary_material_1', sm1.text);
          setValue('link_1', sm1.link);
  
          setValue('supplementary_material_2', sm2.text);
          setValue('link_2', sm2.link);
  
          setValue('supplementary_material_3', sm3.text);
          setValue('link_3', sm3.link);
        } catch (err) {
          history.push('/academyia');
          if (err.response?.status === 403) {
            toast.error(t('toastify:commons.toast_error_403'));
          } else {
            toast.error(t('toastify:commons.toast_error_api'));
          }
        }
      };
  
      fetchData();
    }
  
    setLoading(false);
  }, [id]);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseCategories = await CategoryData.getCategories();
        setCategories(responseCategories.data.categories);
      } catch (err) {
        if (err.response?.status === 403) {
          toast.error(t('toastify:commons.toast_error_403'));
        } else {
          toast.error(t('toastify:commons.toast_error_api'));
        }
      }
    };

    fetchData();
  }, [id, t]);

  const onSubmit = async (data) => {
    try {
      const descriptionText = exampleString
        ? draftToHtml(convertToRaw(exampleString.getCurrentContent()))
        : '';

      if (data.supplementary_material_1 && data.link_1) {
        data.supplementary_material_1 = `<a href="${data.link_1}" target="_blank">${data.supplementary_material_1}</a>`;
      }

      if (data.supplementary_material_2 && data.link_2) {
        data.supplementary_material_2 = `<a href="${data.link_2}" target="_blank">${data.supplementary_material_2}</a>`;
      }

      if (data.supplementary_material_3 && data.link_3) {
        data.supplementary_material_3 = `<a href="${data.link_3}" target="_blank">${data.supplementary_material_3}</a>`;
      }

      data.examples = descriptionText;

      if (card) {
        const responseCard = await FilesData.addFile(
          card,
          `AcademyIA/Company=${idCategory || id}/Card`
        );
        data.id_file = responseCard.data.id;
      }

      console.log('data, DATA', data)

      if (id) {
        await AcademyiaData.updateAcademyIa(idCategory ? idCategory : id, data);
        toast.success(t('toastify:commons.toast_update'));
      } else {
        await AcademyiaData.addAcademyIa(data);
        toast.success(t('toastify:commons.toast_success'));
      }

      if (!isModalInsert) history.push('/academyia');
      if (isModalInsert) isModalInsert(false);
      setValue([{ name: '' }]);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(t('toastify:commons.toast_error_403'));
      } else {
        const toastMessage = id ? 'toast_update_error' : 'toast_error';
        toast.error(t(`toastify:commons.${toastMessage}`));
      }
    }
  };

  const handleStatusChange = () => {
    setStatus((prev) => !prev);
  };

  const titlePage = id
    ? t('form:Academyia.title_edit')
    : t('form:Academyia.title_create');


  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title={titlePage} />
      <Divider />
      {!loading && (
        <form
          {...rest}
          className={clsx(classes.root, className)}
          onSubmit={handleSubmit(onSubmit)}
        >
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={8} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.input_title')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="name"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register({ required: true })}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!errors.id_category}
                >
                  <InputLabel id="id_category_label">
                    {t('form:Categories.input_category')}
                  </InputLabel>
                  <Controller
                    as={
                      <Select
                        labelId="id_category_label"
                        labelWidth={t('form:Categories.input_category').length * 8.5}
                      >
                        {categories?.map((category) => (
                          <MenuItem key={category.id} value={category.id}>
                            {category.name}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                    name="id_category"
                    defaultValue={academy?.id_category || ''}
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl>
              </Grid>
              <Grid item md={8} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.description')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="description"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register({ required: true })}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!errors.id_category}
                >
                  <InputLabel id="id_difficulty_label">
                    {t('form:Academyia.Setting.difficulty')}
                  </InputLabel>
                  <Controller
                    as={
                      <Select
                        labelId="id_category_label"
                        labelWidth={t('form:Academyia.Setting.difficulty').length * 8.5}
                      >
                        {currencies?.map((curr) => (
                          <MenuItem key={curr.value} value={curr.value}>
                            {curr.label}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                    name="difficulty"
                    defaultValue={academy?.difficulty || ''}
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  multiline
                  maxRows={4}
                  label={t('form:Academyia.Setting.about')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="about"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register({ required: true })}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  {t('form:Academyia.Setting.examples')}
                </Typography>
                <Editor
                  editorStyle={{
                    border: '1px solid #C0C0C0',
                    borderRadius: '4px',
                    height: '17rem',
                  }}
                  editorState={exampleString}
                  toolbarClassName="rdw-storybook-toolbar"
                  wrapperClassName="rdw-storybook-wrapper"
                  editorClassName="rdw-storybook-editor"
                  onEditorStateChange={(vl) => setExampleString(vl)}
                  toolbar={{
                    options: ['inline', 'list', 'history', 'link'],
                    link: {
                      inDropdown: false,
                      showOpenOptionOnHover: true,
                      defaultTargetOption: '_blank',
                      options: ['link', 'unlink'],
                    },
                  }}
                />
              </Grid>
              <Grid item md={8} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.url_video')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="url_video"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register({ required: true })}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.url_tool')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="url_tool"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register({ required: true })}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={8} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.supplementary_1')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="supplementary_material_1"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register()}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <TextField
                  fullWidth
                  label={t('Link 1')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="link_1"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register()}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={8} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.supplementary_2')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="supplementary_material_2"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register()}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <TextField
                  fullWidth
                  label={t('Link 2')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="link_2"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register()}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={8} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Academyia.Setting.supplementary_3')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="supplementary_material_3"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register()}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <TextField
                  fullWidth
                  label={t('Link 3')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Library.input_title'),
                    })
                  }
                  name="link_3"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register()}
                  error={!!errors.name}
                />
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.containerImageCard}>
                  {card ? (
                    <img src={URL.createObjectURL(card)}></img>
                  ) : !card && cardUrl ? (
                    <img src={cardUrl}></img>
                  ) : (
                    <></>
                  )}
                </Box>
              </Grid>
              <Divider />
              <Grid item xs={12}>
                <input
                  style={{ display: 'none' }}
                  type="file"
                  id="contained-card-file"
                  name="file_card"
                  accept="image/png, image/jpeg"
                  onChange={(event) => {
                    setCard(event.target.files[0]);
                  }}
                />
                <label htmlFor="contained-card-file">
                  <Button variant="contained" color="primary" component="span">
                    {t('form:Courses.Setting.card_course')}
                  </Button>
                </label>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              size="large"
            >
              {t('button:commons.btn_save')}
              <Save />
            </Button>
          </CardActions>
        </form>
      )}
    </Card>
  );
};
